module.exports = __webpack_public_path__ + "img/sketches.a3ab3225.png";